<template>
  <header class="header">

    <div class="title">
      <img ref="logo" src="~@/assets/images/logo.png">
      <span>{{txt}}</span>
    </div>
    <div class="welcome">
      <span>欢迎您</span>
      <span v-if="username">，{{ username }}！</span>
      <span v-else>登录</span>
      <el-dropdown
        class="ml-xs"
        size="small"
        trigger="hover"
        v-if="username"
      >
        <span class="el-dropdown-link">
          <i class="el-icon-arrow-down"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item @click.native="colorChange">切换主题</el-dropdown-item> -->
            <el-dropdown-item @click.native="edit">修改密码</el-dropdown-item>
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- <el-dialog title="切换主题色" :visible.sync="colorDialog" width="30%">
        <div class="color-picker-content">
            <span class="demonstration">主题色</span>
            <el-color-picker size="big" v-model="themeColor"></el-color-picker>
        </div>  
        <div class="color-picker-btns">
            <el-button type="primary">切 换</el-button>
            <el-button type="primary" plain @click.native='colorDialog = false'>取 消</el-button>
        </div>
    </el-dialog> -->
  </header>
</template>
<script>
import storage from '@/model/utils/localStorage'

export default {
  name: 'TheHeader',
  data() {
    return {
        logo: localStorage.getItem('logo') ? localStorage.getItem('logo') : require('../../assets/images/logo.png'),
        sys_title: localStorage.getItem('sys_title') ? localStorage.getItem('sys_title') : '爱家医健康管理系统',
        txt:'爱加医健康管理系统',
        title: storage.title,
        username: storage.username,
    //   colorDialog: false,
    //   themeColor:'#00c6ae'
    }
  },

  created() {
      if(localStorage.getItem('logo')) {     
        this.$refs.logo.src = localStorage.getItem('logo') 
      }
  },
  methods: {
    // 登出
    logout() {
      storage.clearKeysByUser()
      window.location.reload()
    },
    // 修改密码
    edit() {
      this.$router.push('/editpwd')
    },
    // 切换主题
    // colorChange() {
    //     this.colorDialog = true
    // }
    goToBigScreem() {
      /*let routeUrl = this.$router.resolve({
        name: '大屏预览'
      });
      window.open(routeUrl.href, '_blank');*/
    },
  }
}
</script>
<style lang="scss" scoped>
</style>
<style lang="scss">
.header {
  padding: 0 20px;
  color: #fff;
  background-color: $primary;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    font-size: 22px;
    line-height: 30px;
    display: flex;
    align-items: center;
    img{
      width: 38px;
      height: 38px;
      vertical-align: middle;
      margin-right: 10px;
    }
    .logo{
        width: 42px;
        height: 42px;

    }
    // &:before {
    //   content: '';
    //   margin-right: 10px;
    //   width: 30px;
    //   height: 30px;
    //   background-image: url('~@/assets/images/logo.png');
    //   background-color: transparent;
    //   background-size: cover;
    //   background-position: center;
    //   background-repeat: no-repeat;
    //   display: inline-block;
    //   vertical-align: bottom;
    // }
  }
  .welcome {
    font-size: 14px;
    line-height: 20px;
  }
  .color-picker-content{
        width: 100%;
        display: flex;
        flex-direction: column;
        text-align: center;
        .el-color-picker{
            margin: 20px;
        }
  }
  .color-picker-btns{
      text-align: center;
      margin: 20px;
  }
}
.el-dropdown-link {
  padding: 0px 6px;
  border: 1px solid #ffffff;
  border-radius: 5px;
  cursor: pointer;
  color: #fff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
